import { Translation as Tr } from "../class/Translation.js";

function zah_vratKontaktBox() {
  const K = window.DefLadzo.kontakty;
  const onlineClass = Top.isOnline() ? "online" : "offline";
  const socials = ["facebook", "instagram", "youtube"];

  const socialHtml = socials
    .map((sit) => {
      return `<a class="${sit}" href="${K[sit]}" target="_blank" rel="noopener" aria-label="${sit}"></a>`;
    })
    .join("");

  return `
    <div class="dvKontakt">
      <div class="ladzo-contact-box">
        <div class="photo">
          <span class="status ${onlineClass}"></span>
        </div>

        <div class="contact">
          <a class="tel" href="tel:${K.tel_odkaz}">${K.tel}</a>
          <a class="email" href="mailto:${K.email}">${K.email}</a>
        </div>

        <div class="social">
          ${socialHtml}
        </div>        
      </div>
      <h3>${Tr.l("region")}</h3>
      <div class="spodek"><span class="cz">${Tr.l(
        "ceska_republika",
      )}</span></div><!-- class="spodek"-->
    </div>
  `;
}

function pat_odkazy() {
  Lc.f("pat_odkazy");

  let isOnline = Top.isOnline();
  Lc.log("isOnline", isOnline);
  var $kod = "";

  $kod += '<div class="vrch">';

  var $valMenu = Tr.obj("pata_odkazy_v2_neon");
  Lc.log("$valMenu", $valMenu);
  for (var $k in $valMenu) {
    var $val = $valMenu[$k];

    $kod += '<div class="dv">';
    $kod += "<h3>" + $k + "</h3>";
    $kod += "<ul>";
    for (var $c in $val) {
      var $link = $val[$c];

      $kod += '<li><a href="' + $link + '">' + $c + "</a></li>";
    } //for
    $kod += "</ul></div>";
  } //for

  $kod += zah_vratKontaktBox();

  $kod +=
    '<div id="dvLogo"><a href="/" class="logo"><img src="' +
    $shoptetUpload +
    '/5m_logo_v1.png" alt="" height="44" width="82"></a></div>';
  $kod += '</div><!-- class="vrch"-->';

  $('<div id="dvP"><div class="cntmax">' + $kod + "</div></div>").insertAfter(
    "#footer",
  );
} //function  pat_odkazy()

function zobrazPatickuStranky() {
  //---------spodni radek
  //<p><span class="spnP">Individuální úpravy navrhlo a implementovalo studio <a href="https://shoptet.ladzo.cz/"><span class="non">Corux.cz</span></a></span> <a class="adm" href="https://www.shoptet.cz/">Administrace <img src="https://cdn.myshoptet.com/prj/fdf332c9/master/cms/img/shoptetLogo17x17.gif" width="17" height="17" alt="Shoptet.cz" class="vam"> Shoptet</a> </p>                                                \
  $(
    '<div id="dvPata"><div class="container">    \
    <p><span class="spnP"> <a href="https://shoptet.ladzo.cz/">shoptet.Ladzo.cz</a></span> <a class="adm" href="https://www.shoptet.cz/">, <img src="https://cdn.myshoptet.com/prj/0c160e08/master/cms/img/common/logo/shoptetLogo.svg" width="17" height="17" alt="Shoptet.cz" class="vam"> Shoptet</a> </p>                                                \
    </div></div>',
  ).insertAfter("footer");
} //function zobrazPatickuStranky(){

export function zobrazPatu() {
  zobrazPatickuStranky();
  $(".copyright").insertBefore("#dvPata");
  pat_odkazy();
} //export function  zobrazPatu()
